export default __webpack_public_path__ + "static/media/loader_evmos.03d69248.gif";